import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import { getMessage } from '@gef-ui/localization/messages';
import Check from '@gef-ui/material-icons/Check';
import Xmark from '@gef-ui/material-icons/Xmark';

import { joinString } from 'utils/string';

export const Manager = ({ manager, showIcon = false, withTooltip = false, assigned = false }) => {
	const fullName = joinString(' ', [manager?.surname, manager?.firstname]);

	const tooltipMessage = manager?.managerInArea
		? 'settings:marketPlaceAgencies.managerIncludedInAgency'
		: 'settings:marketPlaceAgencies.managerNotIncludedInAgency';

	const subordinatesInfo = assigned
		? `${manager?.subordinatesInAreaCount}/${manager?.subordinatesCount}`
		: manager?.subordinatesCount;

	const managerContent = (
		<Stack direction="row" spacing={1} sx={{ alignItems: 'center', width: 'fit-content' }}>
			{showIcon && (
				<IconButton
					sx={{ color: manager?.managerInArea ? 'success.main' : 'error.main', p: 0, cursor: 'default' }}
					disableRipple
				>
					{manager?.managerInArea ? <Check /> : <Xmark />}
				</IconButton>
			)}
			<Typography variant="body1" sx={{ color: 'text.primary' }} flexWrap>
				{joinString(' ', [fullName, `(${manager?.channelCode})`, subordinatesInfo])}
			</Typography>
		</Stack>
	);

	return withTooltip ? (
		<Tooltip title={getMessage(tooltipMessage)} placement="right">
			{managerContent}
		</Tooltip>
	) : (
		managerContent
	);
};

Manager.propTypes = {
	assigned: PropTypes.bool,
	manager: PropTypes.shape({
		channelCode: PropTypes.string,
		firstname: PropTypes.string,
		subordinateCount: PropTypes.number,
		surname: PropTypes.string,
		managerInArea: PropTypes.bool,
		subordinatesInAreaCount: PropTypes.number,
		subordinatesCount: PropTypes.number,
		userLogin: PropTypes.string,
	}),
	showIcon: PropTypes.bool,
	withTooltip: PropTypes.bool,
};

export default Manager;
